// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Antd from 'ant-design-vue';
import App from './App'
import 'ant-design-vue/dist/antd.css';
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'

import {request} from "../utils/request"
import api from "../utils/api"
import config from '../base/config'
import utils from '../utils/utils';

import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'

Vue.config.productionTip = false
Vue.use(Antd, VueAxios, axios);

Vue.prototype.$config = config;
Vue.prototype.$request = request;
Vue.prototype.$api = api;
Vue.prototype.$utils = utils;


let isTokenReady = false;
let requestQueue = [];

// 修改后的拦截器
axios.interceptors.request.use(async (config) => {
  let token = localStorage.getItem('token');
  if (token) {
    config.headers['X-Access-Token'] = token;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// 模拟获取 token 的方法
async function fetchToken() {
  try {
    let res = await request({url: api.public.getNavigation});
    let navList = res.data.result;
    sessionStorage.setItem("navList",JSON.stringify(navList.list));
    const token = navList.token;
    localStorage.setItem('token', token);
    axios.defaults.headers.common['X-Access-Token'] = token;

    // token 获取完成后释放所有排队的请求
    isTokenReady = true;
    requestQueue.forEach(cb => cb());
    requestQueue = [];
  } catch (error) {
    console.error('Failed to fetch token:', error);
  }
}

fetchToken()

// 请求拦截器
axios.interceptors.request.use(config => {
  return new Promise((resolve) => {
    if (isTokenReady) {
      resolve(config);
    } else {
      requestQueue.push(() => resolve(config));
    }
  });
}, error => {
  return Promise.reject(error);
});

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js